const initialValue = '# Oo, tanggap ko na, Jane, Wanda.\n## Na wala na akong lalaking makikita.\n### Tanggap ko na magiging mag-isa na lang ako sa buhay.\nMag-aalaga na lang ako ng:\n- pusa\n- aso\n- at dagang kosta.\n\nMag-aaral nalang akong mag *cross-stitch*\nTsaka siguro mag gagantsilyo nalang ako ng\n1. mga bedsheets,\n2. mantel\n3. at kurtina.\n\n`Tanggap ko na, na ako na ang magiging ninang lahat ng mga anak ninyo. At ang magiging thrill ko nalang sa buhay eh magluto ng leche flan tuwing darating na ang pasko.`\n\nMakikipag pilgrimage ako sa Our Lady of Manaoag, kasabay ng mga babaeng napaglipasan na ng ***panahooooon***.\n> #### Doris to Jane and Wanda\n> *Source*: [Status: Single](https://www.youtube.com/watch?v=6o34v4UKino&ab_channel=freelancer0720)';

export function getInitialValue() {
    return getLocalStorage('markdown-HTML') || initialValue;
}

function getLocalStorage(key) {
    return localStorage.getItem(key);
}

export function setLocalStorage(string) {
    // sanitize the string with dompurify
    localStorage.setItem('markdown-HTML', string);
}